export const RequestCertified = () => (
    <>You must request a certified structure chart from the client/counterparty. The chart must establish who the +25% ultimate beneficial owners are and who is responsible for the management of the entity. The certification wording is "Certified to be an accurate depiction of the structure of the client/counterparty and ultimate beneficial owner(s)." The chart should be independently certified by a solicitor, accountant, notary, or other regulated person. Once obtained, please update your answer to the above question and upload the chart.</>
  );

export const EmailSuccess= () => (
    <>Email sent successfully!</>
  );

export const EmailFailed= () => (
    <>Failed to send email</>
  );

export const DealCheck= () => (
    <strong>You cannot proceed with your DealCheck until you have identified your +25% ultimate beneficial owners. If necessary, please raise an enquiry with MLNO or CoND</strong>
  );

export const PageValidation = ({page}) => {
    return (
        <>{page} Already Validated. Skipping Saving.</>
    )
}

export const SaveFailed= () => (
    <strong>Error saving data. Please try again.</strong>
  );

export const SaveFailureMessage = ({ page = "data" }) => {
    return <strong>Failed to save {page}.</strong>;
  };

export const Validating= () => (
    <>Validating ...</>
  );

export const ValidationSuccess= () => (
    <>Validation successful</>
  );

  export const ValidationFailed= () => (
    <>Data NOT Validated. Please fill all values and save the page.</>
  );

export const SaveResultMessage = ({ isValidated, message }) => {
    return (
      <>
        {isValidated ? "Data Validated and Saved Successfully!" : message}
      </>
    );
  };
  
export const ErrorMessage = ({ message }) => {
    return (
      < >
        {message || "Unexpected error occurred"}
      </>
    );
  };

export const FetchDetailErrorMessage = ({ page }) => {
    return (
      <>
        Error fetching {page} details.
      </>
    );
  };

export const SaveResponseMessage = ({ type = "success", message }) => {
    return <>{message}</>;
  };

export const SavingMessage = ({ page = "data" }) => {
    return <>Saving {page} ...</>;
  };
  
export const ValidatingMessage = ({ page = "data" }) => {
    return <>Validating {page} ...</>;
  };

  export const SaveResultMessages = ({ page = "data", validated = false }) => {
    return (
      <>
        {validated
          ? `${page} Validated Successfully.`
          : `${page} Saved Successfully.`}
      </>
    );
  };

export const UndertakeElectronicPEP= () => (
    <>You must undertake an electronic PEP & Sanctions screening on this entity and its ultimate beneficial owners (e.g., SmartSearch, ThirdFort, CreditSafe). If you do not have an electronic screening provider, please contact COD for additional support ...</>
  );
  
export const MediaSearchConducted= () => (
    <>You are required to conduct proportionate media searches on the client/ counterparty. This may be done through a standard Google search or by utilising any dedicated media scouring tools available to your business.</>
  );
export const InfluenceTransaction = () =>(
  <>Please identify and undertake an electronic screening on this intermediary</>
);
export const GeneralErrorMessage = ({ action = "update", page = "data", error = "Unexpected error" }) => {
    return (
      <>
         Failed to {action} {page}: {error}
      </>
    );
  };